import {
    addCleanHeatAndAcAtom,
    addEvExpandAtom,
    addHeatPumpWaterHeaterAtom,
    addHvacUseAtom,
    addInductionStoveAtom,
    addPeopleAtom,
    changeAddPeopleAtom,
    evsAtom,
    numEvsAtom,
} from '@/ui/atoms/form-atoms';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

export function useClearInputs() {
    // Form inputs.
    const [addEvExpand, setAddEvExpand] = useAtom(addEvExpandAtom);
    const [numEvs, setNumEvs] = useAtom(numEvsAtom);
    const [evs, setEvs] = useAtom(evsAtom);

    const [changeAddPeople, setChangeAddPeople] = useAtom(changeAddPeopleAtom);
    const [addPeople, setAddPeople] = useAtom(addPeopleAtom);
    const [addHvacUse, setAddHvacUse] = useAtom(addHvacUseAtom);
    const [addInductionStove, setAddInductionStove] = useAtom(
        addInductionStoveAtom
    );
    const [addCleanHeatAndAc, setAddCleanHeatAndAc] = useAtom(
        addCleanHeatAndAcAtom
    );
    const [addHeatpumpWaterHeater, setAddHeatpumpWaterHeater] = useAtom(
        addHeatPumpWaterHeaterAtom
    );

    const clearEv = useCallback(() => {
        setAddEvExpand(false);
        setNumEvs(0);
        setEvs([]);
    }, [setAddEvExpand, setEvs, setNumEvs]);

    const clearInductionStove = useCallback(() => {
        setAddInductionStove(false);
    }, [setAddInductionStove]);

    const clearCleanHeatAndAc = useCallback(() => {
        setAddCleanHeatAndAc(false);
    }, [setAddCleanHeatAndAc]);

    const clearHeatpumpWaterHeater = useCallback(() => {
        setAddHeatpumpWaterHeater(false);
    }, [setAddHeatpumpWaterHeater]);

    const clearOtherScenarios = useCallback(() => {
        setChangeAddPeople(false);
        setAddPeople('');
        setAddHvacUse(false);
    }, [setAddHvacUse, setAddPeople, setChangeAddPeople]);

    const clearAll = useCallback(() => {
        clearEv();
        clearOtherScenarios();
        clearInductionStove();
        clearCleanHeatAndAc();
        clearHeatpumpWaterHeater();
    }, [
        clearEv,
        clearOtherScenarios,
        clearInductionStove,
        clearCleanHeatAndAc,
        clearHeatpumpWaterHeater,
    ]);

    return {
        clearEv,
        clearOtherScenarios,
        clearInductionStove,
        clearCleanHeatAndAc,
        clearHeatpumpWaterHeater,
        clearAll,
    };
}
